import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <Container>
        <SectionHeading
          align="center"
          eyebrow="Confianza"
          title="Empresas y clientes que ya confían en nosotros"
          description="La puntualidad, la seguridad y la atención personalizada son nuestra mejor carta de presentación."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item, index) => (
            <figure
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 animate-fade-up"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: item.valoracion }).map((_, starIndex) => (
                  <i key={starIndex} className="ri-star-fill text-base leading-none" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{item.texto}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {item.nombre.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-heading font-semibold text-foreground-950">
                    {item.nombre}
                  </span>
                  <span className="block text-xs text-foreground-500">{item.cargo}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </Container>
    </section>
  );
}